export const DAYS = [
    { v: 1, l: "Lun" }, { v: 2, l: "Mar" }, { v: 3, l: "Mer" }, { v: 4, l: "Gio" },
    { v: 5, l: "Ven" }, { v: 6, l: "Sab" }, { v: 7, l: "Dom" },
];

export const dayLabels = (days) => DAYS.filter((d) => days?.includes(d.v)).map((d) => d.l).join(", ");

export const toMin = (t) => { const [h, m] = (t || "0:0").split(":").map(Number); return h * 60 + m; };

// Ore in centesimi (1h15' → "1,25", 1h → "1,00"): formato unico di tutto il modulo Timbratura/Presenze
export const fmtH = (h) => {
    if (h == null || h === "" || Number.isNaN(Number(h))) return "—";
    return Number(h).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const endFromStart = (start, hours) => {
    const total = (toMin(start) + Math.round((Number(hours) || 0) * 60)) % (24 * 60);
    return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
};

export const FREQ_OPTIONS = [
    { value: "weekly", label: "Settimanale" },
    { value: "every_n_weeks", label: "Ogni N settimane" },
    { value: "monthly", label: "Mensile (settimana del mese)" },
    { value: "every_n_months", label: "Ogni N mesi" },
    { value: "every_n_days", label: "Ogni N giorni" },
    { value: "dates", label: "Date specifiche" },
];

export const WEEK_OF_MONTH_OPTIONS = [
    { value: 1, label: "1ª settimana del mese" },
    { value: 2, label: "2ª settimana del mese" },
    { value: 3, label: "3ª settimana del mese" },
    { value: 4, label: "4ª settimana del mese" },
    { value: -1, label: "Ultima settimana del mese" },
];

const N_MONTHS_LABELS = { 2: "bimestrale", 3: "trimestrale", 4: "quadrimestrale", 6: "semestrale", 12: "annuale" };

// Normalizza il legacy "biweekly" → "every_n_weeks" n=2
export const normFreq = (f) => (f?.type === "biweekly" ? { type: "every_n_weeks", n: 2, anchor: f.anchor } : f || { type: "weekly" });

// Frequenze "a data": il giorno lo decide la data, i giorni della settimana non si applicano
export const isDateDriven = (f) => ["every_n_days", "dates"].includes(normFreq(f).type);

// Interventi medi a settimana per giorno selezionato (o totali per le frequenze a data)
export const freqWeight = (freq) => {
    const f = normFreq(freq);
    const n = Number(f.n) || 1;
    switch (f.type) {
        case "every_n_weeks": return 1 / n;
        case "monthly": return 12 / 52;
        case "every_n_months": return 12 / 52 / n;
        case "every_n_days": return 7 / n;
        case "dates": {
            const ds = [...(f.dates || [])].sort();
            if (!ds.length) return 0;
            const spanW = Math.floor((new Date(ds[ds.length - 1]) - new Date(ds[0])) / 864e5 / 7) + 1;
            return ds.length / Math.max(1, spanW);
        }
        default: return 1;
    }
};

export const weekInterventions = (freq, days) => (isDateDriven(freq) ? freqWeight(freq) : (days?.length || 0) * freqWeight(freq));

const fmtD = (iso) => (iso ? new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString("it-IT") : "");

export const freqLabel = (freq) => {
    const f = normFreq(freq);
    const wom = WEEK_OF_MONTH_OPTIONS.find((o) => o.value === Number(f.week_of_month));
    switch (f.type) {
        case "every_n_weeks":
            return `ogni ${f.n} settimane${f.anchor ? ` (dal ${fmtD(f.anchor)})` : ""}`;
        case "monthly":
            return `mensile · ${wom ? wom.label.toLowerCase() : ""}`.trim();
        case "every_n_months": {
            const base = N_MONTHS_LABELS[Number(f.n)] || `ogni ${f.n} mesi`;
            const [y, m] = String(f.anchor_month || "").split("-");
            return `${base} · ${wom ? wom.label.toLowerCase() : ""}${m ? ` (da ${m}/${y})` : ""}`.trim();
        }
        case "every_n_days":
            return `ogni ${f.n} giorni${f.anchor ? ` (dal ${fmtD(f.anchor)})` : ""}`;
        case "dates": {
            const ds = [...(f.dates || [])].sort();
            const shown = ds.slice(0, 3).map((d) => d.slice(8, 10) + "/" + d.slice(5, 7)).join(", ") + (ds.length > 3 ? "…" : "");
            return `${ds.length} date fisse${ds.length ? `: ${shown}` : ""}`;
        }
        default:
            return "settimanale";
    }
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
